module.exports = __webpack_public_path__ + "static/img/index4(1)_12.eb39c3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index4(1)_12.png
// module id = 3133
// module chunks = 1